/**
 * ServerErrorPage — 500 error page for unhandled server errors.
 *
 * Rendered OUTSIDE DatabaseProvider so it's accessible even when
 * the app fails to initialize. Matches NotFoundPage styling.
 */

import { useTranslation } from "react-i18next"

export function ServerErrorPage() {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-dvh items-center justify-center bg-background p-8">
      <div className="max-w-sm text-center">
        <p className="mb-2 text-6xl font-bold text-muted-foreground/30">500</p>

        <h1 className="mb-2 text-xl font-semibold">
          {t("Something went wrong")}
        </h1>

        <p className="mb-8 text-sm text-muted-foreground">
          {t(
            "An unexpected error occurred. Please try again or contact support if the issue persists.",
          )}
        </p>

        <div className="flex items-center justify-center gap-3">
          <a
            href="/"
            className="inline-flex items-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
          >
            {t("Go to Today")}
          </a>
        </div>
      </div>
    </div>
  )
}
